// YouTube Thumbnail Downloader Tool — grab thumbnails in every resolution.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const youtubeThumbnailTool: Tool = {
  id: "youtube-thumbnail-downloader",
  name: () => m.yt_tool_name(),
  description: () => m.yt_tool_description(),
  icon: "🖼️",
  basePath: "/youtube-thumbnail-downloader",
  status: "stable",
  tags: ["youtube", "thumbnail", "downloader", "image"],
  pages: [
    {
      name: () => m.yt_nav_main(),
      path: "/youtube-thumbnail-downloader",
      description: () => m.yt_nav_main_desc(),
      icon: "🖼️",
    },
    {
      name: () => m.yt_hd_nav(),
      path: "/youtube-thumbnail-downloader/hd",
      description: () => m.yt_nav_hd_desc(),
      icon: "🎬",
    },
    {
      name: () => m.yt_shorts_nav(),
      path: "/youtube-thumbnail-downloader/shorts",
      description: () => m.yt_nav_shorts_desc(),
      icon: "📱",
    },
  ],
};
